import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const MenuBarIcon = React.memo(
  ({
    fill = variables['colors-mc-primary'],
    width = '20',
    height = '15.048',
    viewBox = '0 0 20 15.048'
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <rect
        id='Rectangle_940'
        data-name='Rectangle 940'
        width='16'
        height='2.667'
        rx='1.333'
        fill={fill}
      />
      <rect
        id='Rectangle_941'
        data-name='Rectangle 941'
        width='11.827'
        height='2.667'
        rx='1.333'
        transform='translate(0 6.19)'
        fill={fill}
      />
      <rect
        id='Rectangle_942'
        data-name='Rectangle 942'
        width='20'
        height='2.667'
        rx='1.333'
        transform='translate(0 12.381)'
        fill={fill}
      />
    </svg>
  )
);
MenuBarIcon.displayName = 'MenuBarIcon';

export default MenuBarIcon;
